'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _effects = require('redux-saga/effects');

var _webUtils = require('@vezeeta/web-utils');

var _Pharma = require('../actions/Pharma');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchPrescriptionSettings),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchPharmaProducts),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(fetchLabTestsProducts),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(fetchPrevAddedMedications),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(submitEprescription),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(fetchEPresc),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(fetchPresc),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(fetchScansCatalog),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(activitiesSaga);

function fetchPrescriptionSettings(action) {
  var prescriptionSettingsAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchPrescriptionSettings$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          prescriptionSettingsAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context.next = 6;
          return prescriptionSettingsAPI.get(_webUtils.Urls.getPrescriptionSettings + '?productKey=' + action.productKey + '&language=' + culture, header);

        case 6:
          response = _context.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context.next = 12;
            break;
          }

          _context.next = 10;
          return (0, _effects.put)((0, _Pharma.getPrescriptionSettingsSuccess)(_extends({}, response.data, action.payload, {
            productKey: action.productKey
          })));

        case 10:
          _context.next = 14;
          break;

        case 12:
          _context.next = 14;
          return (0, _effects.put)((0, _Pharma.getPrescriptionSettingsFail)(_extends({}, action.payload, {
            productKey: action.productKey
          })));

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchPharmaProducts(action) {
  var pharmaProductsAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchPharmaProducts$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          pharmaProductsAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context2.next = 6;
          return pharmaProductsAPI.get(_webUtils.Urls.pharmaProductShape + '?Query=' + action.keyWord + '&From=1&Size=100', header);

        case 6:
          response = _context2.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context2.next = 12;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _Pharma.getPharmaProductsSuccess)(_extends({}, response.response, action.payload, {
            keyWord: action.keyWord
          })));

        case 10:
          _context2.next = 14;
          break;

        case 12:
          _context2.next = 14;
          return (0, _effects.put)((0, _Pharma.getPharmaProductsFail)(_extends({}, action.payload, {
            keyWord: action.keyWord
          })));

        case 14:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function fetchLabTestsProducts(action) {
  var labTestsProductAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchLabTestsProducts$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          labTestsProductAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);

          if (culture.split('-')[0] === 'en') {
            culture = 'en-US';
          }

          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context3.next = 7;
          return labTestsProductAPI.get(_webUtils.Urls.getLabTests + '?query=' + action.keyWord, header);

        case 7:
          response = _context3.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context3.next = 13;
            break;
          }

          _context3.next = 11;
          return (0, _effects.put)((0, _Pharma.getLabTestsProductsSuccess)(_extends({}, response.response, action.payload, {
            keyWord: action.keyWord
          })));

        case 11:
          _context3.next = 15;
          break;

        case 13:
          _context3.next = 15;
          return (0, _effects.put)((0, _Pharma.getLabTestsProductsFail)(_extends({}, action.payload, {
            keyWord: action.keyWord
          })));

        case 15:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function fetchPrevAddedMedications() {
  var api, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchPrevAddedMedications$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          api = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context4.next = 6;
          return api.get('' + _webUtils.Urls.getPreivouslyAddedItems, header);

        case 6:
          response = _context4.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context4.next = 12;
            break;
          }

          _context4.next = 10;
          return (0, _effects.put)((0, _Pharma.getPreviouslyAddedMedicationsSuccess)(_extends({}, response.data)));

        case 10:
          _context4.next = 14;
          break;

        case 12:
          _context4.next = 14;
          return (0, _effects.put)((0, _Pharma.getPreviouslyAddedMedicationsFail)());

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function submitEprescription(action) {
  var submitEprescriptionAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function submitEprescription$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          submitEprescriptionAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context5.next = 6;
          return submitEprescriptionAPI.post(_webUtils.Urls.upsertEPrescription, action.payload, header);

        case 6:
          response = _context5.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context5.next = 12;
            break;
          }

          _context5.next = 10;
          return (0, _effects.put)((0, _Pharma.submitEprescriptionSuccess)(_extends({}, response.data, action.payload)));

        case 10:
          _context5.next = 14;
          break;

        case 12:
          _context5.next = 14;
          return (0, _effects.put)((0, _Pharma.submitEprescriptionFail)(_extends({}, action.payload)));

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function fetchEPresc(action) {
  var getEPrescAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchEPresc$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          getEPrescAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);

          if (culture.split('-')[0] === 'en') {
            culture = 'en-US';
          }

          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context6.next = 7;
          return getEPrescAPI.get(_webUtils.Urls.getEPrescription + '?operationKey=' + action.payload.reservationKey, header);

        case 7:
          response = _context6.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context6.next = 13;
            break;
          }

          _context6.next = 11;
          return (0, _effects.put)((0, _Pharma.getEPrescriptionSuccess)(_extends({}, response.data, action.payload)));

        case 11:
          _context6.next = 15;
          break;

        case 13:
          _context6.next = 15;
          return (0, _effects.put)((0, _Pharma.getEPrescriptionFail)(_extends({}, action.payload)));

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function fetchPresc(action) {
  var accountToken, Headers, getPrescAPI, response;
  return _regenerator2.default.wrap(function fetchPresc$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          accountToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          Headers = [{
            key: 'x-vzt-authentication',
            value: accountToken
          }];
          getPrescAPI = new _webUtils.API();
          _context7.next = 5;
          return getPrescAPI.get('' + _webUtils.Urls.prescription.getPrescription + action.payload.reservationKey, Headers);

        case 5:
          response = _context7.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context7.next = 11;
            break;
          }

          _context7.next = 9;
          return (0, _effects.put)((0, _Pharma.getPrescriptionSuccess)(_extends({}, response.data, action.payload)));

        case 9:
          _context7.next = 13;
          break;

        case 11:
          _context7.next = 13;
          return (0, _effects.put)((0, _Pharma.getPrescriptionFail)(_extends({}, action.payload)));

        case 13:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

function fetchScansCatalog(action) {
  var labTestsProductAPI, authToken, culture, header, response;
  return _regenerator2.default.wrap(function fetchScansCatalog$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          labTestsProductAPI = new _webUtils.API();
          authToken = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
          culture = _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);

          if (culture.split('-')[0] === 'en') {
            culture = 'en-US';
          }

          header = [{
            key: 'x-vzt-authentication',
            value: '' + authToken
          }, {
            key: 'Language',
            value: '' + culture
          }];
          _context8.next = 7;
          return labTestsProductAPI.get(_webUtils.Urls.getScans + '?query=' + action.keyWord, header);

        case 7:
          response = _context8.sent;

          if (!_webUtils.STATUS.isSuccess(response.status)) {
            _context8.next = 13;
            break;
          }

          _context8.next = 11;
          return (0, _effects.put)((0, _Pharma.getScansCatalogSuccess)(_extends({}, response.response, action.payload, {
            keyWord: action.keyWord
          })));

        case 11:
          _context8.next = 15;
          break;

        case 13:
          _context8.next = 15;
          return (0, _effects.put)((0, _Pharma.getScansCatalogFail)(_extends({}, action.payload, {
            keyWord: action.keyWord
          })));

        case 15:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function activitiesSaga() {
  return _regenerator2.default.wrap(function activitiesSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.PHARMA_PRODUCTS.LOAD, fetchPharmaProducts);

        case 2:
          _context9.next = 4;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.LAB_TESTS_PRODUCTS.LOAD, fetchLabTestsProducts);

        case 4:
          _context9.next = 6;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.GET_PRESCRIPTION_SETTINGS.LOAD, fetchPrescriptionSettings);

        case 6:
          _context9.next = 8;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.SUBMIT_EPRESCRIPTION.SUBMIT, submitEprescription);

        case 8:
          _context9.next = 10;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.GET_EPRESC.LOAD, fetchEPresc);

        case 10:
          _context9.next = 12;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.GET_PRESC.LOAD, fetchPresc);

        case 12:
          _context9.next = 14;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.GET_PREVIOUSLY_ADDED_MEDICATIONS.LOAD, fetchPrevAddedMedications);

        case 14:
          _context9.next = 16;
          return (0, _effects.takeLatest)(_Pharma.PHARMA.SCANS_CATALOG.LOAD, fetchScansCatalog);

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}

exports.default = activitiesSaga;
module.exports = exports['default'];